// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tex-clickable:hover{color:red}.tex-clickable{cursor:pointer}\n", "",{"version":3,"sources":["webpack://./@isle-project/components/tex/tex.css"],"names":[],"mappings":"AAAA,qBACC,SAAA,CAGD,eACC,cAAA","sourcesContent":[".tex-clickable:hover {\r\n\tcolor: red;\r\n}\r\n\r\n.tex-clickable {\r\n\tcursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
